import { createSlice } from "@reduxjs/toolkit";
import { UiStore } from "./ui.interface";

const initialState: UiStore = {
    isSideMenuOpen: false,
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        openSideMenu(state: UiStore) {
            state.isSideMenuOpen = true;
        },
        closeSideMenu(state: UiStore) {
            state.isSideMenuOpen = false;
        },
    }
});

export const uiReducer = uiSlice.reducer;
export const uiActions = uiSlice.actions;
